// @ts-nocheck
import * as React from "react";
import { IconOffset } from "@toolkit/Framework/Types/Icon";

const SettingsFill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 2a1.68 1.68 0 0 1 1.63 1.68v1.03a.34.34 0 0 0 .22.29l.079.038A.38.38 0 0 0 15.26 5l.77-.74.008-.008a1.67 1.67 0 0 1 2.362.008l1.34 1.37c.32.314.5.742.5 1.19l-.008.166A1.63 1.63 0 0 1 19.74 8l-.81.74a.34.34 0 0 0 0 .37l.033.071c.061.113.15.189.267.189h1.09c.93.005 1.68.76 1.68 1.69V13a1.68 1.68 0 0 1-1.62 1.67h-1.09a.34.34 0 0 0-.29.22l-.035.07a.34.34 0 0 0 .035.3l.73.73.008.008a1.67 1.67 0 0 1-.008 2.362l-1.34 1.34c-.31.319-.735.5-1.18.5l-.166-.01a1.72 1.72 0 0 1-1.024-.49l-.76-.77a.34.34 0 0 0-.37 0l-.071.033c-.113.061-.189.15-.189.267v1.09A1.69 1.69 0 0 1 12.94 22h-1.89a1.68 1.68 0 0 1-1.68-1.62v-1.09a.34.34 0 0 0-.22-.29l-.079-.038A.38.38 0 0 0 8.74 19l-.77.74a1.67 1.67 0 0 1-2.37 0l-1.34-1.36a1.66 1.66 0 0 1-.5-1.19l.01-.166A1.72 1.72 0 0 1 4.26 16l.81-.74a.34.34 0 0 0 0-.37l-.033-.071c-.061-.113-.15-.189-.267-.189H3.68A1.69 1.69 0 0 1 2 12.94v-1.89c0-.928.752-1.68 1.68-1.68h1.03A.34.34 0 0 0 5 9.15l.038-.079A.38.38 0 0 0 5 8.74l-.779-.779A1.67 1.67 0 0 1 4.26 5.6l1.37-1.34c.31-.319.735-.5 1.18-.5l.166.01A1.72 1.72 0 0 1 8 4.26l.74.81a.34.34 0 0 0 .37 0l.071-.033c.112-.061.189-.15.189-.267V3.68A1.69 1.69 0 0 1 11.06 2Zm-1 6.5a3.5 3.5 0 1 0 0 7l.192-.005A3.5 3.5 0 0 0 15.5 12l-.005-.192A3.5 3.5 0 0 0 12 8.5Zm1.06 2.44a1.5 1.5 0 1 1-2.12 2.12 1.5 1.5 0 0 1 2.12-2.12Z"
            />
        </svg>
    );
};

export const SettingsFillOffset: IconOffset = {
    vertical: 8,
    horizontal: 8,
};

export default React.memo(SettingsFill);
